import bowlingDay from '../../assets/images/galleries/bowling-day.jpg';
import g2 from '../../assets/images/galleries/8.png';
import g3 from '../../assets/images/galleries/7.png';
import g4 from '../../assets/images/galleries/4.jpg';
import g5 from '../../assets/images/galleries/5.jpg';
import g6 from '../../assets/images/galleries/6.jpg';
import breakingBarriers from '../../assets/images/galleries/breaking-barriers.png';
import howToBuildCompetititveRobots from '../../assets/images/galleries/how-to-build-competitive-robots.jpg';
import proxymVisit from '../../assets/images/galleries/proxym-visit.jpg';
import rocketBot from '../../assets/images/galleries/rocket-bot.jpg';

interface Image {
    name?: string;
    image: string;
    date?: string;
}

const galleries: Image[] = [
    {
        name: 'Bowling Day',
        image: bowlingDay,
    },
    { image: g2 },
    { image: g3 },
    { image: g4 },
    { image: g5 },
    { image: g6 },
    { image: breakingBarriers },
    {
        image: howToBuildCompetititveRobots,
        name: 'How to build competitive robots workshop',
    },
    { image: proxymVisit, name: 'Proxym visit' },
    { image: rocketBot, name: 'Rocket bot 1.0', date: 'December 10th, 2023' },
];

export default galleries;
